<template>
    <div>
      <h3 class="mb-4 text-primary">Payment Details</h3>
      <div class="table-responsive">
        <table v-if="selectedViewPayment" class="table table-striped table-hover table-bordered">
          <thead class="thead-dark">
            <tr>
              <th>ID</th>
              <th>Account ID</th>
              <th>User First Name</th>
              <th>Teacher NIC</th>
              <th>Package Type</th>
              <th>Total Students Level</th>
              <th>Total Subjects</th>
              <th>Status</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Payment Date</th>
              <th>Payment Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(paymentItem, index) in selectedViewPayment" :key="index">
              <td>{{ paymentItem.id }}</td>
              <td>{{ paymentItem.account_id }}</td>
              <td>{{ paymentItem.user.first_name }}</td>
              <td>{{ paymentItem.teacher.teacher_nic }}</td>
              <td>{{ paymentItem.package.type }}</td>
              <td>{{ paymentItem.total_students_level }}</td>
              <td>{{ paymentItem.total_subjects }}</td>
              <td>{{ paymentItem.account_status.status_name }}</td>
              <!-- <td>
                <span
                  :class="{
                    'badge bg-success': paymentItem.status === 'Paid',
                    'badge bg-danger': paymentItem.status === 'Not Paid',
                    'badge bg-secondary': paymentItem.status === 'Pending'
                  }"
                >
                </span>
              </td> -->
              <td>{{ paymentItem.start_date }}</td>
              <td>{{ paymentItem.end_date }}</td>
              <td>{{ paymentItem.payment_date }}</td>
              <td>{{ paymentItem.payment_price }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else class="alert alert-warning">
          <p>No payment details available.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'MorePaymentDetails',
  
    props: {
      accountId: {
        type: Number,
        required: true,
      },
    },
  
    data() {
      return {
        selectedViewPayment: null, // Initialize the payment details
      };
    },
  
    mounted() {
      this.getPaymentDetails(this.accountId); // Fetch payment details when component mounts
    },
  
    methods: {
      async getPaymentDetails(accountId) {
        try {
          const response = await axios.get(`/get-payments-by-account/${accountId}`);
          this.selectedViewPayment = response.data; // Assuming the response contains the payment details
        } catch (error) {
          console.error('Error fetching payment details:', error);
          this.selectedViewPayment = null; // Reset in case of an error
        }
      },
  
      // Add a beforeRouteLeave guard
      beforeRouteLeave(to, from, next) {
        // You can use this to set a global state or perform some actions before leaving
        next(); // Proceed to leave the route
      },
    },
  };
  </script>
  
  <style scoped>
  table {
    margin-bottom: 20px;
  }
  
  .badge {
    font-size: 0.9em;
    padding: 0.5em;
  }
  </style>
  